<div id="layout" class="f_col container layout_sm">
  <app-view-title bgImage="assets-countries/header_background.png" class="portrait_only">{{('userShare.DYN.' + params?.claimType)  | translate}}</app-view-title>
  <div class="scroll_wrapper">
    <div class="card_container">
      <div class="card_share mb_20">
        <app-paragraph class="title_card" textAlign="center">{{'share.mode.within' | translate}}</app-paragraph>
        <app-view-deco-image
          [disabled]="!sync.isOnline"
          [colorDisabledIcon]="!sync.isOnline ? '#f51d2a' : undefined"
          [disabledIcon]="!sync.isOnline ? 'wifi' : undefined"
          margin="sm"
          class="img_share"
          imageUrl="assets-countries/flag.png"
          (click)="sync.isOnline ? shareIntoCountry() : sync.loaderOffline()">
        </app-view-deco-image>
        <!-- tostash -->
      </div>
      <div class="card_share">
        <app-paragraph class="title_card" textAlign="center">{{'share.mode.outside' | translate}}</app-paragraph>
        <app-view-deco-image
          margin="sm"
          class="img_share"
          imageUrl="assets/images/international-mode.webp"
          (click)="navPermission()">
        </app-view-deco-image>
      </div>
    </div>
    <div class="mb_10 f_col portrait_only">
      <div class="flex mt_20">
        <app-back-btn (btnClicked)="nav.to('claim-card', undefined, {queryParams: params})"></app-back-btn>
      </div>
    </div>
  </div>
</div>
